// extracted by mini-css-extract-plugin
export var arrowButton = "arrow-button-module--arrow-button--v7J4e";
export var dark = "arrow-button-module--dark---uGHm";